<template>
  <div class="no-data">
    <img src="@/assets/暂无内容.png" />
    <div>{{title}}</div>
  </div>
</template>

<script>
export default {
  name: "NoData",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.no-data {
  text-align: center;
  div {
    height: 100px;
    line-height: 60px;
    color: #333;
    text-align: center;
    font-size: 12px;
  }

  img {
    width: 40%;
  }
}
</style>